/* eslint-disable no-console */
/* eslint-disable max-len */
import React, { memo, useContext, useEffect, useState } from 'react';
import { Grid, useMediaQuery } from '@mui/material';
import EventCards from './EventsCard';
import BookMarks from './BookMarks';
import PopularFeeds from './PopularFeeds';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import Comments from '../Reusable/Comments';
import { getBookmarks, getPopularFeeds } from '../../../actions/feeds_actions_new';
import { useSelector } from 'react-redux';
import { feedActionContext, feedRoutes } from '../..';
import { Theme } from '@mui/material/styles';

const RightPart = (props) =>
{
	const isMobileSM = useMediaQuery((theme: Theme) => theme?.breakpoints?.down('lg'));
	const { setSelectedFilter } = props;
	const { type } = useParams();
	const [ searchParams ] = useSearchParams();
	const paramsValue = searchParams.get('post');
	const [ count, setCount ] = useState({
		bookmarks     : 0,
		popular_feeds : 0
	});

	const { feedCardActn, feedAction } = useContext(feedActionContext);
	const isCommentOpened = feedCardActn?.[0] === 'comments' && !feedAction?.is_full_screen;
	const bookmarks = (!type || (type !== 'draft' && type !== 'bookmarks')) && !isCommentOpened && !paramsValue && feedCardActn[0] !== 'allEventCmnt' && type !== 'celebrationevents';
	const popularFeeds = (!type || (type !== 'draft' && type !== 'popularfeeds')) && !isCommentOpened;

	const userData = useSelector((state:any) => state.mysession.session);
	const navigate = useNavigate();
	const getFeedCount = async (key) =>
	{
		const query = {
			count   : true,
			uid     : userData?.userId,
			comid   : userData?.companyId,
			empRole : userData?.empRole,
			role    : userData?.role
		};

		try
		{
			const res = key === 'bookmarks' ? await getBookmarks(query) : await getPopularFeeds(query);

			if (res?.status)
			{
				setCount((prev) => ({ ...prev, [key]: res?.count ?? 0 }));
			}
		}
		catch (err)
		{
			// eslint-disable-next-line no-console
			console.error('err');
		}
	};

	useEffect(() =>
	{
		switch (type)
		{
			case (undefined):
				getFeedCount('bookmarks');
				getFeedCount('popular_feeds');
				break;
			case ('popularfeeds'):
				getFeedCount('bookmarks');
				break;
			case ('myactivity'):
			case ('connections'):
				getFeedCount('bookmarks');
				break;
			case ('bookmarks'):
				getFeedCount('popular_feeds');
		}
	}, [ type ]);

	useEffect(() =>
	{
		if (type && !feedRoutes?.includes(type))
		{
			navigate('/news');
		}
	}, [ type ]);

	return (
		<Grid container
			height={isCommentOpened ? 'var(--percent100)' : '100%'}
			sx={{
				position        : 'sticky',
				top             : isMobileSM ? '136px' : ' 144px',
				maxHeight       : '80vh',
				scrollbarGutter : 'stable',
				paddingX        : 'var(--pixel8)',
				paddingBottom   : 'var(--pixel8)',
				overflowY       : 'hidden',
				flexWrap        : 'nowrap',
				flexDirection   : 'column',
				transition      : 'overflow-y 0.3s ease-in-out, opacity 0.3s ease-in-out',
				'&:hover'       : {
					overflowY : 'auto',
					opacity   : 1
				}
			}}
		>
			{!isCommentOpened && !paramsValue && <EventCards />}
			{(Boolean(bookmarks)) &&
			<BookMarks key={[ count?.bookmarks, type, feedAction ]} count={count?.bookmarks} setSelectedFilter={setSelectedFilter}/>}
			{(Boolean(popularFeeds) && !paramsValue && feedCardActn[0] !== 'allEventCmnt' && type !== 'celebrationevents') &&
			<PopularFeeds />} {/** In Populer section count and view-all is not required */}
			{Array.isArray(feedCardActn) && feedCardActn?.length > 0 && isCommentOpened && type !== 'celebrationevents' && <Comments key={feedCardActn?.[1]?._id} from='feeds' />}
		</Grid>
	);
};

export default memo(RightPart);